import { useLayoutEffect, useRef, useState } from "react"
import { App } from "antd"
import { watermarkStaffVideo } from "~/api/staff"
import { uploadFile } from "~/api/upload"
import { useResourceUploadActivity } from "~/components/ResourceUploadField/UploadScope"

export const useDownloadVideo = (
  src: string,
  value: string,
  onChange: (url: string) => void,
) => {
  const operation = useRef<AbortController | null>(null)
  const [stage, setStage] = useState<"idle" | "generating" | "uploading">(
    "idle",
  )
  const [error, setError] = useState("")
  const { message } = App.useApp()
  const pending = stage !== "idle"
  useResourceUploadActivity(pending)
  useLayoutEffect(() => {
    setStage("idle")
    setError("")
    return () => {
      operation.current?.abort()
      operation.current = null
    }
  }, [src, value])

  const cancel = () => {
    operation.current?.abort()
    operation.current = null
    setStage("idle")
  }

  const generate = async () => {
    if (operation.current) return
    const controller = new AbortController()
    operation.current = controller
    setStage("generating")
    setError("")
    try {
      const file = await watermarkStaffVideo(
        { video_url: src.trim() },
        controller.signal,
      )
      controller.signal.throwIfAborted()
      setStage("uploading")
      const { data } = await uploadFile({
        file,
        filename: "watermarked-video.mp4",
        type: "video",
        signal: controller.signal,
      })
      controller.signal.throwIfAborted()
      onChange(data.url)
      void message.success("下载视频已生成，保存模板后生效")
    } catch (failure) {
      if (!controller.signal.aborted)
        setError(
          failure instanceof Error ? failure.message : "生成失败，请重试",
        )
    } finally {
      if (operation.current === controller && !controller.signal.aborted) {
        operation.current = null
        setStage("idle")
      }
    }
  }

  return { stage, pending, error, generate, cancel }
}
